import { apiClient } from "services/api-client"

export const getOfficesPaged = async (tenant, page, perPage) => {
    return await apiClient.get(`/company/office/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}`)
}

export const getOfficeById = async (id) => {
    return await apiClient.get(`/company/office/${id}`)
}

export const addOffice = async (data) => {
    return await apiClient.post('/company/office', data)
}

export const editOffice = async (id, data) => {
    return await apiClient.put(`/company/office/${id}`, data)
}

export const deleteOffice = async (id) => {
    return await apiClient.delete(`/company/office/${id}`)
}